import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { container } from './container';
import type { ICoreDataWrapper } from './exception';

export const PatsnapCopilotFeedBackService = Symbol('PatsnapCopilotFeedBackService');

export interface PatsnapCopilotFeedBackService {
    send(data: { type?: 'LIKE' | 'DISLIKE'; query: string; answer: string; question: string; intent: string; product: string; comment?: string; }): Promise<void>;
}

@injectable()
export class PatsnapCopilotFeedBackServiceImpl implements PatsnapCopilotFeedBackService {
    send(data: { type?: 'LIKE' | 'DISLIKE'; query: string; answer: string; question: string; intent: string; product: string; comment?: string; }): Promise<void> {
        return container.RnDHttp.post<ICoreDataWrapper<void>>({
            headers: {
                'X-API-Version': '1.0',
            },
            data,
            url: `${process.env.VUE_APP_CORE_BASIC_SERVICE_URI}/core-copilot-api/analytics/copilot/feedback`,
        }).then(() => {});
    }
}
